var collapseChevron = 'jmu1rxd';
var collapseContent = 'jmu1rx6';
var collapseGroup = 'jmu1rx3';
var collapseHeader = 'jmu1rxc';
var collapseLabel = 'jmu1rxe';
var collapseLabelButton = 'jmu1rxb';
var collapseLabelButtonTruncated = 'jmu1rxa';
var collapseLabelTruncated = 'jmu1rxf';
var collapseRoot = 'jmu1rx5';
var collapseTrail = 'jmu1rxg';
var fillHeight = 'jmu1rx4';
var fillWidth = 'jmu1rx9';
var fitWidth = 'jmu1rx8';
var leftPanelVariant = 'jmu1rx7';
var size = {md:'jmu1rxh',lg:'jmu1rxi'};

export { collapseChevron, collapseContent, collapseGroup, collapseHeader, collapseLabel, collapseLabelButton, collapseLabelButtonTruncated, collapseLabelTruncated, collapseRoot, collapseTrail, fillHeight, fillWidth, fitWidth, leftPanelVariant, size };
//# sourceMappingURL=collapse.css.js.map
